<template>
  <div style="background-color:#E5E5E5">
    <div class="container">
      <div class="outer-container">
        <h2 class="heading_fonts gap-t-100">
          Why Choose Upskill
        </h2>
        <h5 class="manrope text-center pb-3">
          Advantages of hiring through Upskill Assessment and Bootcamp
        </h5>
        <div class="grid">
          <div class="white-bg">
            <h3 style="background: #184DBD; min-height:230px" class="manrope">
              Hiring decisions now faster, easier and more efficient
            </h3>
            <h3 class="custom_black">
              Our automated process reduces various tasks of job posting, CV
              sorting , taking assessment tests, pre qualifying interviews and
              other HR processing work that requires extra time.
            </h3>
          </div>

          <div class="white-bg">
            <h3 style="background: #184DBD; min-height:230px">
              High quality and engaging candidates
            </h3>
            <h3 class="custom_black">
              Our automated recruitment process is faster and helps identify
              high quality talents.
            </h3>
          </div>
          <div class="white-bg">
            <h3 style="background: #184DBD; min-height:230px">
              Financial success guaranteed
            </h3>
            <h3 class="custom_black">
              The whole process is free. We only require an admin fee after
              successful placement.
            </h3>
          </div>
          <div class="white-bg">
            <h3 style="background: #184DBD; min-height:230px">
              We help you curate the most qualified candidates
            </h3>
            <h3>
              Our screening process automation lets you focus on the best people
              for the job during the actual interview.
            </h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style scoped>
.heading_fonts {
  font: 800 2.1rem/2.3rem 'Manrope';
  letter-spacing: -2%;
  color: #29292b;
  text-align: center;
}

.outer-container {
  padding: 0 25px;
  padding-bottom: 90px;
}

.outer-container h4 {
  font-family: 'Manrope';
  font-size: 24px;
  font-weight: 700;

  line-height: 32px;
  letter-spacing: -0.6px;
  color: #3c4663;

  padding-bottom: 50px;
}
.grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  grid-gap: 49px;
}
.grid h3:first-child {
  padding-top: 40px;
  padding-left: 40px;
  padding-right: 30px;
  font-family: 'Manrope';
  text-transform: capitalize;
  font-size: 24px;
  font-weight: 400;

  line-height: 30px;
  letter-spacing: 0px;
  color: white;
  padding-bottom: 48px;
}
.grid h3:last-child {
  padding-top: 40px;
  padding-left: 40px;
  padding-right: 30px;
  font-family: 'Manrope';
  text-transform: capitalize;
  font-size: 18px;
  font-weight: 400;

  line-height: 30px;
  letter-spacing: 0px;
  padding-bottom: 48px;
}
.grid p {
  padding-left: 40px;
  font-family: 'Manrope';
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 24px;
  color: #84888b;
  padding-right: 25px;
}
.white-bg {
  background-color: white;
  box-shadow: 0px 10px 30px #3c46630d;
  border-radius: 10px;
  min-height: 300px;
  border: 1px solid #a6c2d7;
}
@media only screen and (min-width: 601px) and (max-width: 1100px) {
  .grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }
}
@media only screen and (max-width: 600px) {
  .container {
    padding-left: 0;
    padding-right: 0;
  }
  .grid {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
  }
  .outer-container {
    padding: 0 20px;
    padding-top: 50px;
    padding-bottom: 45px;
  }

  .outer-container h4 {
    font-family: 'Poppins';
    font-size: 18px;
    font-weight: 700;
    letter-spacing: 0px;
    line-height: 24px;
    color: #304f64;
    padding-top: 0px;
    padding-bottom: 10px;
  }
  .grid h3 {
    padding-bottom: 20px;
    padding-top: 30px;
    padding-left: 10px;
    padding-right: 0;
  }
}
@media only screen and (min-width: 1300px) {
  .container {
    max-width: 1350px !important;
  }
}
</style>
